// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ecc4b3f4","750":"aafa9a29","803":"a3818674","952":"593532d6"}[chunkId] + ".chunk.js";
};